import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../../../connection/api';
import '../../../../assets/ExcelImport.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFileExcel, 
  faCheckCircle, 
  faExclamationTriangle, 
  faTimesCircle, 
  faClock,
  faInfoCircle,
  faUpload,
  faDatabase,
  faListAlt,
  faPlusCircle,
  faDownload,
  faFilter,
  faTable,
  faSync,
  faShieldAlt,
  faArrowRight,
  faCloudUploadAlt,
  faExclamationCircle,
  faBan,
  faMapMarkerAlt,
  faFolderOpen,
  faCopy,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import alert_box from '../../../../alert/alert_box';

const ExcelImport = () => {
  const [data, setData] = useState([]);
  const [cardNumbers, setCardNumbers] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [fileName, setFileName] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [totalColumns, setTotalColumns] = useState(0);
  const [existenceResults, setExistenceResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const [validationErrors, setValidationErrors] = useState([]);
  const [circle_id, setCircle_id] = useState('');
  const [dataAfter, setDataAfter] = useState([]);
  const [bazna, setBazna] = useState([]);
  const [errors, setErrors] = useState('');
  const [importLoading, setImportLoading] = useState(false);
  const [duplicateDetails, setDuplicateDetails] = useState([]);
  const [columnMapping, setColumnMapping] = useState([]);

  const getCircle = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/circle/index", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      setBazna(response.data.AllData);
    } catch (error) {
      console.error("Error fetching circles:", error);
    }
  };

  const handleChange = (e) => { 
    setCircle_id(e.target.value);
  };

  const sendToDatabase = async (e) => {
    e.preventDefault();
    
    if (!circle_id) {
      alert_box('هەڵە', 'تکایە بازنە هەڵبژێرە', 'warning', 'باشە');
      return;
    }
  
    if (dataAfter.length === 0) {
      alert_box('هەڵە', 'هیچ داتایەک نیە بۆ ناردن', 'warning', 'باشە');
      return;
    }
  
    setImportLoading(true);
  
    try {
      const token = localStorage.getItem('token');
      const response = await api.post("/admin/import", 
        {
          circle_id: circle_id,
          data: dataAfter
        }, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          timeout: 30000
        }
      );
  
      if (response.data.success === false) {
        if (response.data.message === 'base_not_found') {
          alert_box('هەڵە هەیە', ' بنکەی ' + response.data.base_name + ' لە سیستمەکەدا تۆمارنەکراوە  ', 'warning', 'باشە');
        } else {
          alert_box('هەڵە', response.data.message || 'هەڵەیەک ڕوویدا', 'error', 'باشە');
        }
      } else {
        alert_box('سەرکەوتووبوو', 'داتاکە بە سەرکەوتوویی نێردرا', 'success', 'باشە');
        resetForm();
      }
    } catch (error) {
      console.error('Import error:', error);
      if (error.response?.status === 422) {
        const validationErrors = error.response.data.errors;
        alert_box('هەڵە', `Validation failed: ${JSON.stringify(validationErrors)}`, 'error', 'باشە');
      } else if (error.response?.data?.message) {
        alert_box('هەڵە', error.response.data.message, 'error', 'باشە');
      } else if (error.message) {
        alert_box('هەڵە', error.message, 'error', 'باشە');
      } else {
        alert_box('هەڵە', 'هەڵەیەک ڕوویدا لە کاتی ناردنی داتاکە', 'error', 'باشە');
      }
    } finally {
      setImportLoading(false);
    }
  };
  
  const resetForm = () => {
    setData([]);
    setDataAfter([]);
    setExistenceResults([]);
    setFileName('');
    setCardNumbers([]);
    setCircle_id('');
    setHeaders([]);
    setTotalRows(0);
    setTotalColumns(0);
    setValidationErrors([]);
    setActiveTab('all');
    setError('');
    setDuplicateDetails([]);
    setColumnMapping([]);
    
    const fileInput = document.getElementById('file-input');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  useEffect(() => {
    getCircle();
  }, []);

  const getValidToken = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No authentication token found. Please login again.");
    }
    return token;
  };

  const handleApiError = (error) => {
    if (error.response?.status === 401) {
      setError('Authentication failed. Please login again.');
      localStorage.removeItem("token");
    } else if (error.response?.status === 404) {
      setError('API endpoint not found. Please check the URL.');
    } else if (error.response?.status === 422) {
      setError(`Validation failed: ${JSON.stringify(error.response.data.errors)}`);
    } else if (error.response?.data?.message) {
      setError(error.response.data.message);
    } else if (error.message) {
      setError(error.message);
    } else {
      setError('An error occurred while processing your request.');
    }
  };

  // Validate card number format
  const validateCardNumber = (cardNumber) => {
    if (!cardNumber && cardNumber !== 0) {
      return { isValid: false, error: 'Card number is empty' };
    }
    
    const cardStr = String(cardNumber).trim();
    
    if (cardStr === '') {
      return { isValid: false, error: 'Card number is empty' };
    }
    
    if (cardStr.length < 3) {
      return { isValid: false, error: 'Card number too short (min 3 characters)' };
    }
    
    if (cardStr.length > 50) {
      return { isValid: false, error: 'Card number too long (max 50 characters)' };
    }
    
    if (!/^[a-zA-Z0-9\-_]+$/.test(cardStr)) {
      return { isValid: false, error: 'Card number contains invalid characters' };
    }
    
    return { isValid: true, error: null };
  };

  // Validate address field
  const validateAddress = (address) => {
    if (!address && address !== 0) {
      return { isValid: false, error: 'Address is empty' };
    }
    
    const addressStr = String(address).trim();
    
    if (addressStr === '') {
      return { isValid: false, error: 'Address is empty' };
    }
    
    if (addressStr.length < 2) {
      return { isValid: false, error: 'Address too short (min 5 characters)' };
    }
    
    if (addressStr.length > 200) {
      return { isValid: false, error: 'Address too long (max 200 characters)' };
    }
    
    return { isValid: true, error: null };
  };

  const validateBase = (base) => {
    if (!base && base !== 0) {
      return { isValid: false, error: 'Base is empty' };
    }
    
    const baseStr = String(base).trim();
    
    if (baseStr === '') {
      return { isValid: false, error: 'Base is empty' };
    }
    
    if (baseStr.length > 200) {
      return { isValid: false, error: 'Base too long (max 200 characters)' };
    }
    
    return { isValid: true, error: null };
  };

  const validateFullName = (name) => {
    if (!name && name !== 0) {
      return { isValid: false, error: 'Name is empty' };
    }
    
    const nameStr = String(name).trim();
    
    if (nameStr === '') {
      return { isValid: false, error: 'Name is empty' };
    }
    
    if (nameStr.length > 200) {
      return { isValid: false, error: 'Name too long (max 200 characters)' };
    }
    
    return { isValid: true, error: null };
  };

  const validateMobile = (mobile) => {
    if (!mobile && mobile !== 0) {
      return { isValid: false, error: 'Mobile is empty' };
    }
    
    const mobileStr = String(mobile).trim();
    
    if (mobileStr === '') {
      return { isValid: false, error: 'Mobile is empty' };
    }
    
    if (mobileStr.length > 200) {
      return { isValid: false, error: 'Mobile too long (max 200 characters)' };
    }
    
    return { isValid: true, error: null };
  };

  // Validate entire row and return validation status
  const validateRow = (row, rowIndex) => {
    const errors = [];
    
    // Validate card number (column index 4)
    const cardNumber = row[4];
    const cardValidation = validateCardNumber(cardNumber);
    if (!cardValidation.isValid) {
      errors.push({
        field: 'Card Number',
        error: cardValidation.error,
      });
    }
    
    // Validate address (column index 3)
    const address = row[3];
    const addressValidation = validateAddress(address);
    if (!addressValidation.isValid) {
      errors.push({
        field: 'Address',
        error: addressValidation.error,
      });
    }

    // Validate base (column index 6)
    const base = row[6];
    const baseValidation = validateBase(base);
    if (!baseValidation.isValid) {
      errors.push({
        field: 'Base',
        error: baseValidation.error,
      });
    }

    // Validate name (column index 1)
    const name = row[1];
    const nameValidation = validateFullName(name);
    if (!nameValidation.isValid) {
      errors.push({
        field: 'Name',
        error: nameValidation.error,
      });
    }

    // Validate mobile (column index 2)
    const mobile = row[2];
    const mobileValidation = validateMobile(mobile);
    if (!mobileValidation.isValid) {
      errors.push({
        field: 'Mobile',
        error: mobileValidation.error,
      });
    }

    return {
      isValid: errors.length === 0,
      errors: errors
    };
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setData([]);
    setDataAfter([]);
    setExistenceResults([]);
    setValidationErrors([]);
    setActiveTab('all');
    setError('');
    setDuplicateDetails([]);
    setColumnMapping([]);

    setFileName(file.name);
    
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        if (jsonData.length > 0) {
          // وەرگرتنی هێدەرەکان و فیلتەرکردنی ستوونە نەویستراوەکان
          const originalHeaders = jsonData[0];
          
          // دروستکردنی mapping بۆ نیشاندانی ستوونە ڕاستەقینەکان
          const mapping = originalHeaders.map((header, index) => {
            return {
              originalIndex: index,
              header: header,
              show: !['PER_FIRST', 'PER_FATHER', 'PER_GRAND'].includes(header)
            };
          }).filter(item => item.show);

          const filteredHeaders = mapping.map(item => item.header);
          
          setHeaders(filteredHeaders);
          setColumnMapping(mapping);
          
          const rowData = jsonData.slice(1);
          
          // دروستکردنی dataAfter بۆ ناردن بۆ API
          const formDataArray = rowData.map((row) => {
            return {
              fullname: row[1],
              mobile: row[2], 
              address: row[3], 
              card_number: row[4],
              unit_office: row[5],
              base: row[6],
            };
          });
          
          setDataAfter(formDataArray);
          
          const validationResults = [];
          const rowsWithValidation = [];
          
          rowData.forEach((row, index) => {
            const validation = validateRow(row, index);
            
            // دروستکردنی ڕیزێکی فیلتەرکراو بۆ پیشاندان
            const filteredRow = mapping.map(item => row[item.originalIndex]);
            
            rowsWithValidation.push({
              ...filteredRow, // ئەمە ڕیزە فیلتەرکراوەکەیە
              _originalRow: row, // ئەمە ڕیزە ڕاستەقینەکەیە بە هەموو ستوونەکان
              _validation: validation,
              _originalIndex: index,
              _columnMapping: mapping // mapping بۆ گەڕانەوە بۆ ڕیزە ڕاستەقینەکە
            });
            
            if (validation.errors.length > 0) {
              validationResults.push(...validation.errors);
            }
          });
          
          setValidationErrors(validationResults);
          setData(rowsWithValidation);
          
          // تەنها card_numberە ڕاستەکان کۆبکەرەوە لە یەک arrayدا
          const validCardNumbers = rowsWithValidation
            .filter(row => row._validation.isValid)
            .map(row => row._originalRow[4]) // card_number لە ڕیزە ڕاستەقینەکە وەربگرە
            .filter(cardNumber => cardNumber !== undefined && cardNumber !== '' && cardNumber !== null);

          setCardNumbers(validCardNumbers);
          setTotalRows(rowsWithValidation.length);
          setTotalColumns(filteredHeaders.length); // ژمارەی ستوونە فیلتەرکراوەکان

          if (validCardNumbers.length > 0) {
            // یەک جار هەموو card_numberەکان بنێرە
            checkAllCardNumbersOnce(validCardNumbers);
          } else {
            console.log('No valid card numbers found for API checking');
          }
        }
      } catch (error) {
        setError('Error reading Excel file: ' + error.message);
        console.error('File reading error:', error);
      }
    };
    
    reader.onerror = () => {
      setError('Error reading file. Please try again.');
    };
    
    reader.readAsBinaryString(file);
  };

  const checkAllCardNumbersOnce = async (cardNumbersArray) => {
    if (!cardNumbersArray || cardNumbersArray.length === 0) {
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      const token = getValidToken();
      
      // پاککردنەوە و جیاکردنەوەی card_number دووبارەکان
      const uniqueCardNumbers = [...new Set(cardNumbersArray
        .filter(card => card && String(card).trim() !== '')
        .map(card => String(card).trim())
      )];

      if (uniqueCardNumbers.length === 0) {
        throw new Error('No valid card numbers to check');
      }

      console.log(`Sending ${uniqueCardNumbers.length} unique card numbers to API`);

      const response = await api.get('/listCardNumber', 
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          timeout: 3300000
        }
      );

      if (response.data.success === true) {
        const listDataCardNumber = response.data.card_number_list;
        
        // Extract just the card numbers from the response
        const existingCardNumbers = listDataCardNumber.map(item => item.card_number);
        
        // Find duplicates
        const duplicates = uniqueCardNumbers.filter(cardNumber => 
          existingCardNumbers.includes(cardNumber)
        );
        
        // دروستکردنی زانیاری ورد بۆ دووبارەکان
        const duplicateInfo = duplicates.map(duplicateCard => {
          const existingRecord = listDataCardNumber.find(item => 
            item.card_number === duplicateCard
          );
          const excelRows = data.filter(row => 
            String(row._originalRow[4]).trim() === duplicateCard
          );
          
          return {
            card_number: duplicateCard,
            existing_id: existingRecord?.id,
            existing_data: existingRecord,
            excel_rows: excelRows.map(row => ({
              row_index: row._originalIndex + 1,
              fullname: row._originalRow[1],
              mobile: row._originalRow[2],
              address: row._originalRow[3],
              unit_office: row._originalRow[5],
              base: row._originalRow[6]
            })),
            duplicate_count: excelRows.length
          };
        });
        
        setDuplicateDetails(duplicateInfo);
        
        if (duplicates.length > 0) {
          // console.log(`Found ${duplicates.length} duplicate card numbers:`, duplicates);
          alert_box(
            'کارتی دووبارە دۆزرایەوە', 
            `${duplicates.length} کارتی دووبارە دۆزرایەوە. تکایە سەیری پەڕەی "Existing" بکە بۆ زانیاری زیاتر.`, 
            'warning', 
            'باشە'
          );
        } else {
          console.log('No duplicate card numbers found');
        }
        
        // دروستکردنی existenceResults بۆ پشکنینی ئاستی ڕیز
        const results = uniqueCardNumbers.map(cardNumber => {
          const exists = existingCardNumbers.includes(cardNumber);
          const duplicateInfoItem = duplicateInfo.find(d => d.card_number === cardNumber);
          
          return {
            card_number: cardNumber,
            exists: exists,
            existingData: exists ? listDataCardNumber.find(item => item.card_number === cardNumber) : null,
            duplicateInfo: duplicateInfoItem,
            message: exists ? 'کارتەکە پێشتر تۆمارکراوە' : 'کارتەکە نوێیە'
          };
        });
        
        setExistenceResults(results);
        console.log(`Received ${results.length} results from API`);
        
      } else {
        throw new Error('Invalid response format from API');
      }
      
    } catch (error) {
      console.error('Error in bulk card number check:', error);
      
      if (error.response?.status === 413 || error.message.includes('Payload too large')) {
        alert_box('تێبینی', 'ژمارەی کارتەکان زۆرن، پشکنین بە شێوازی هێواش دەکرێت', 'info', 'باشە');
        await checkCardNumbersSequential(cardNumbersArray);
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const checkCardNumbersSequential = async (cardNumbersArray) => {
    const token = getValidToken();
    const results = [];
    
    const chunkSize = 50;
    const chunks = [];
    
    for (let i = 0; i < cardNumbersArray.length; i += chunkSize) {
      chunks.push(cardNumbersArray.slice(i, i + chunkSize));
    }
    
    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      
      try {
        const payload = {
          card_numbers: chunk,
        };

        const response = await api.post('/admin/check-card-numbers-exist', 
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            timeout: 15000
          }
        );

        if (response.data.results) {
          results.push(...response.data.results);
          setExistenceResults([...results]);
        }
        
        if (i < chunks.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
      } catch (chunkError) {
        console.error(`Chunk ${i + 1} failed:`, chunkError);
        
        const remainingCards = chunk.filter(card => 
          !results.some(result => result.card_number === card)
        );
        
        for (const cardNumber of remainingCards) {
          try {
            const individualResult = await checkSingleCardNumber(cardNumber, token);
            results.push(individualResult);
            setExistenceResults([...results]);
          } catch (individualError) {
            results.push({
              card_number: cardNumber,
              exists: false,
              error: individualError.message || 'Check failed',
              failed: true
            });
            setExistenceResults([...results]);
          }
          
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
    }
    
    return results;
  };

  const checkSingleCardNumber = async (cardNumber, token) => {
    const encodedCardNumber = encodeURIComponent(cardNumber);
    
    try {
      const response = await api.get(`/admin/check-card-number-exists/${encodedCardNumber}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 10000
      });
      
      return {
        card_number: cardNumber,
        exists: response.data.exists || false,
        existingData: response.data.existingData || null,
        message: response.data.message || ''
      };
    } catch (error) {
      try {
        const response = await api.get(`/admin/check-card-number-exists?card_number=${encodedCardNumber}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          timeout: 10000
        });
        
        return {
          card_number: cardNumber,
          exists: response.data.exists || false,
          existingData: response.data.existingData || null,
          message: response.data.message || ''
        };
      } catch (secondError) {
        throw new Error(secondError.response?.data?.message || secondError.message || 'Network error');
      }
    }
  };

  const getCardNumberFromRow = (row) => {
    // card_number لە ڕیزە ڕاستەقینەکە وەربگرە (لە کۆلەمی ٤)
    return row._originalRow[4];
  };

  const getRowStatus = (row) => {
    if (!row._validation.isValid) {
      return { 
        status: 'invalid', 
        text: 'Invalid', 
        icon: faBan, 
        color: '#dc3545', 
        bgColor: '#f8d7da', 
        badge: 'danger',
        errors: row._validation.errors
      };
    }

    const cardNumber = getCardNumberFromRow(row);
    
    const result = existenceResults.find(result => 
      result.card_number && result.card_number.toString() === cardNumber.toString()
    );
    
    if (!result) return { 
      status: 'pending', 
      text: 'Checking...', 
      icon: faClock, 
      color: '#6c757d', 
      bgColor: '#f8f9fa', 
      badge: 'secondary' 
    };
    
    if (result.failed) return { 
      status: 'error', 
      text: 'Check Failed', 
      icon: faTimesCircle, 
      color: '#dc3545', 
      bgColor: '#f8d7da', 
      badge: 'danger' 
    };
    
    if (result.exists) return { 
      status: 'exists', 
      text: 'Already Exists', 
      icon: faExclamationTriangle, 
      color: '#856404', 
      bgColor: '#fff3cd', 
      badge: 'warning',
      duplicateInfo: result.duplicateInfo,
      existingData: result.existingData
    };
    
    return { 
      status: 'new', 
      text: 'New Card', 
      icon: faCheckCircle, 
      color: '#155724', 
      bgColor: '#d4edda', 
      badge: 'success' 
    };
  };

  const getExistingCardNumbers = () => {
    return existenceResults.filter(result => result.exists && !result.failed);
  };

  const getNewCardNumbers = () => {
    return existenceResults.filter(result => !result.exists && !result.failed);
  };

  const getValidRows = () => {
    return data.filter(row => row._validation.isValid);
  };

  const getInvalidRows = () => {
    return data.filter(row => !row._validation.isValid);
  };

  const getNewDataRows = () => {
    return getValidRows().filter((row) => {
      const cardNumber = getCardNumberFromRow(row);
      const result = existenceResults.find(result => 
        result.card_number && result.card_number.toString() === cardNumber.toString()
      );
      return result && !result.exists && !result.failed;
    });
  };

  const clearError = () => setError('');

  const existingCount = getExistingCardNumbers().length;
  const newCount = getNewCardNumbers().length;
  const failedCount = existenceResults.filter(r => r.failed).length;
  const invalidCount = getInvalidRows().length;
  const validCount = getValidRows().length;
  const newDataRows = getNewDataRows();

  const exportNewDataToExcel = () => {
    if (newDataRows.length === 0) return;

    // دروستکردنی هێدەرەکان بە ستوونە ڕاستەقینەکان
    const exportHeaders = columnMapping.map(item => item.header);
    
    const ws = XLSX.utils.aoa_to_sheet([exportHeaders, ...newDataRows.map(row => {
      const { _validation, _originalIndex, _originalRow, _columnMapping, ...cleanRow } = row;
      return cleanRow;
    })]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "New Data");
    XLSX.writeFile(wb, `new_data_${Date.now()}.xlsx`);
  };

  const filteredData = () => {
    switch (activeTab) {
      case 'new':
        return getValidRows().filter((row) => {
          const cardNumber = getCardNumberFromRow(row);
          const result = existenceResults.find(result => 
            result.card_number && result.card_number.toString() === cardNumber.toString()
          );
          return result && !result.exists && !result.failed;
        });
      case 'existing':
        return getValidRows().filter((row) => {
          const cardNumber = getCardNumberFromRow(row);
          const result = existenceResults.find(result => 
            result.card_number && result.card_number.toString() === cardNumber.toString()
          );
          return result && result.exists && !result.failed;
        });
      case 'invalid':
        return getInvalidRows();
      default:
        return data;
    }
  };

  const renderCircleOptions = () => {
    const role = localStorage.getItem('role');
    
    if (role === 'admin' && bazna && bazna.id) {
      return (
        <option key={bazna.id} value={bazna.id}>
          {bazna.circle_name}
        </option>
      );
    } else if (role === 'superadmin' && Array.isArray(bazna)) {
      return bazna.map((item) => (
        <option key={item.id} value={item.id}>
          {item.circle_name}
        </option>
      ));
    }
    
    return null;
  };

  const renderDuplicateDetails = (duplicateInfo) => {
    if (!duplicateInfo) return null;

    return (
      <div className="duplicate-details-popover">
        <div className="duplicate-header">
          <FontAwesomeIcon icon={faCopy} />
          <strong>زانیاری دووبارە</strong>
        </div>
        
        <div className="duplicate-section">
          <div className="duplicate-info-item">
            <span className="label">ژمارەی کارت:</span>
            <span className="value">{duplicateInfo.card_number}</span>
          </div>
          
          {duplicateInfo.existing_id && (
            <div className="duplicate-info-item">
              <span className="label">ID لە بنکەدراوە:</span>
              <span className="value">#{duplicateInfo.existing_id}</span>
            </div>
          )}
        </div>

        <div className="duplicate-section">
          <div className="section-title">
            <FontAwesomeIcon icon={faTable} />
            <span>ڕیزەکانی Excel ({duplicateInfo.duplicate_count})</span>
          </div>
          {duplicateInfo.excel_rows.map((row, index) => (
            <div key={index} className="excel-row-info">
              <div className="row-header">
                <span className="row-number">ڕیز #{row.row_index}</span>
              </div>
              <div className="row-details">
                <div className="detail-item">
                  <span>ناو:</span>
                  <span>{row.fullname || '—'}</span>
                </div>
                <div className="detail-item">
                  <span>مۆبایل:</span>
                  <span>{row.mobile || '—'}</span>
                </div>
                <div className="detail-item">
                  <span>ناونیشان:</span>
                  <span>{row.address || '—'}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const DuplicateDetailsPanel = () => {
    if (duplicateDetails.length === 0) return null;

    return (
      <div className="duplicate-panel">
        {/* <div className="panel-header">
          <FontAwesomeIcon icon={faExclamationTriangle} />
          <h3>کارتە دووبارەکان</h3>
          <span className="badge warning">{duplicateDetails.length}</span>
        </div> */}
        
        <div className="duplicate-cards">
          {/* {duplicateDetails.map((detail, index) => (
            <div key={index} className="duplicate-card">
              <div className="card-header">
                <div className="card-title">
                  <FontAwesomeIcon icon={faCopy} />
                  <span>کارت: {detail.card_number}</span>
                </div>
                <div className="card-badge">
                  {detail.duplicate_count} ڕیز
                </div>
              </div>
              
              <div className="card-content">
                <div className="info-grid">
                  <div className="info-item">
                    <span className="label">ID لە بنکەدراوە:</span>
                    <span className="value">#{detail.existing_id}</span>
                  </div>
                  <div className="info-item">
                    <span className="label">ژمارەی ڕیزەکان:</span>
                    <span className="value">{detail.duplicate_count}</span>
                  </div>
                </div>
                
                <div className="excel-rows-preview">
                  <div className="preview-title">
                    <FontAwesomeIcon icon={faTable} />
                    <span>ڕیزەکان لە Excel:</span>
                  </div>
                  {detail.excel_rows.slice(0, 2).map((row, rowIndex) => (
                    <div key={rowIndex} className="row-preview">
                      <span className="row-num">ڕیز #{row.row_index}</span>
                      <span className="row-name">{row.fullname || '—'}</span>
                    </div>
                  ))}
                  {detail.excel_rows.length > 2 && (
                    <div className="more-rows">
                      + {detail.excel_rows.length - 2} ڕیزی تر...
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    );
  };

  return (
    <div className="excel-import-container">
      {/* Upload Card */}
      <div className="upload-card">
        <div className="upload-content">
          <div className="upload-icon-section">
            <FontAwesomeIcon icon={faUpload} className="upload-main-icon" />
          </div>
          <div className="upload-info">
            <div className="upload-header">
              <FontAwesomeIcon icon={faCloudUploadAlt} className="upload-title-icon" />
              <h3>Upload Excel File</h3>
            </div>
            
            <p className="upload-subtitle">Drag and drop your Excel file or click to browse</p>
            
            <div className={`upload-zone ${data.length > 0 ? 'has-data' : ''}`}>
              <div className="upload-zone-content">
                <FontAwesomeIcon icon={faFileExcel} className="upload-zone-icon" />
                <div className="upload-zone-text">
                  <span className="upload-zone-title">Select Excel File</span>
                  <span className="upload-zone-desc">Supports .xlsx, .xls, .csv files</span>
                </div>
              </div>
              
              <div className="file-input-wrapper">
                <input
                  type="file"
                  accept=".xlsx, .xls, .csv"
                  onChange={handleFileUpload}
                  className="file-input"
                  id="file-input"
                  disabled={loading}
                />
                <label htmlFor="file-input" className="browse-button">
                  <FontAwesomeIcon icon={faFolderOpen} />
                  Browse Files
                </label>
              </div>
            </div>

            {fileName && (
              <div className="file-preview-card">
                <div className="file-preview-header">
                  <div className="file-info">
                    <FontAwesomeIcon icon={faFileExcel} className="file-icon" />
                    <div className="file-details">
                      <span className="file-name">{fileName}</span>
                      <span className="file-stats">
                        {totalRows} rows • {totalColumns} columns
                      </span>
                    </div>
                  </div>
                  <div className="file-status">
                    <FontAwesomeIcon icon={faCheckCircle} className="status-success" />
                    <span>Ready</span>
                  </div>
                </div>
                
                {data.length > 0 && (
                  <div className="file-actions">
                    <button 
                      onClick={resetForm} 
                      className="action-button primary"
                      disabled={loading}
                    >
                      <FontAwesomeIcon icon={faTimesCircle} />
                      Clear File
                    </button>
                  </div>
                )}
              </div>
            )}

            {!fileName && (
              <div className="upload-features">
                <div className="feature-item">
                  <FontAwesomeIcon icon={faCheckCircle} className="feature-icon" />
                  <span>Excel & CSV Support</span>
                </div>
                <div className="feature-item">
                  <FontAwesomeIcon icon={faCheckCircle} className="feature-icon" />
                  <span>Automatic Validation</span>
                </div>
                <div className="feature-item">
                  <FontAwesomeIcon icon={faCheckCircle} className="feature-icon" />
                  <span>Duplicate Detection</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="loading-card">
          <div className="loading-content">
            <div className="loading-spinner">
              <FontAwesomeIcon icon={faSync} className="spinning" />
            </div>
            <div className="loading-text">
              <h4>Validating Card Numbers</h4>
              <p>Checking database for existing records...</p>
              <div className="progress-wrapper">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${(existenceResults.length / cardNumbers.length) * 100}%` }}
                  />
                </div>
                <span className="progress-text">
                  {existenceResults.length} of {cardNumbers.length} completed
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Results Section */}
      {(data.length > 0 || validationErrors.length > 0) && (
        <div className="results-section">
          <div className="section-header">
            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
            <h2>ئەنجام</h2>
          </div>

          {/* پانێلی زانیاری دووبارەکان */}
          <DuplicateDetailsPanel />

          {/* Summary Cards */}
          <div className="summary-cards">
            <div className="summary-card total">
              <div className="card-icon">
                <FontAwesomeIcon icon={faDatabase} />
              </div>
              <div className="card-content">
                <span className="card-number">{data.length}</span>
                <span className="card-label">هەموو داتاکان</span>
              </div>
            </div>
            
            {invalidCount > 0 && (
              <div className="summary-card danger">
                <div className="card-icon">
                  <FontAwesomeIcon icon={faBan} />
                </div>
                <div className="card-content">
                  <span className="card-number">{invalidCount}</span>
                  <span className="card-label">داتای ناروست</span>
                </div>
              </div>
            )}
            
            {existingCount > 0 && (
              <div className="summary-card warning">
                <div className="card-icon">
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div className="card-content">
                  <span className="card-number">{existingCount}</span>
                  <span className="card-label">کارتی دووبارە</span>
                </div>
              </div>
            )}
            
            {newCount > 0 && (
              <div className="summary-card success">
                <div className="card-icon">
                  <FontAwesomeIcon icon={faPlusCircle} />
                </div>
                <div className="card-content">
                  <span className="card-number">{newCount}</span>
                  <span className="card-label">داتای نوێ</span>
                </div>
                <button onClick={exportNewDataToExcel} className="card-action">
                  <FontAwesomeIcon icon={faDownload} />
                </button>
              </div>
            )}
          </div>
         
          {/* Data Tabs */}
          <div className="data-section">
            {/* Navigation Tabs */}
            <div className="navigation-tabs">
              <div className="tabs-container">
                <div className="tabs-scroll">
                  <button 
                    className={`nav-tab ${activeTab === 'all' ? 'active' : ''}`}
                    onClick={() => setActiveTab('all')}
                  >
                    <FontAwesomeIcon icon={faTable} />
                    <span>All Data</span>
                    <span className="tab-badge">{data.length}</span>
                  </button>
                  
                  <button 
                    className={`nav-tab ${activeTab === 'new' ? 'active' : ''}`}
                    onClick={() => setActiveTab('new')}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} />
                    <span>New Data</span>
                    <span className="tab-badge success">{newCount}</span>
                  </button>
                  
                  <button 
                    className={`nav-tab ${activeTab === 'existing' ? 'active' : ''}`}
                    onClick={() => setActiveTab('existing')}
                  >
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <span>Existing</span>
                    <span className="tab-badge warning">{existingCount}</span>
                  </button>
                  
                  {invalidCount > 0 && (
                    <button 
                      className={`nav-tab ${activeTab === 'invalid' ? 'active' : ''}`}
                      onClick={() => setActiveTab('invalid')}
                    >
                      <FontAwesomeIcon icon={faBan} />
                      <span>Invalid</span>
                      <span className="tab-badge danger">{invalidCount}</span>
                    </button>
                  )}
                </div>
              </div>

              {/* Import Action Section */}
              {newCount > 0 && existingCount==0  && invalidCount==0 && (
                <div className="import-action-card">
                  <div className="import-header">
                    <FontAwesomeIcon icon={faCloudUploadAlt} className="import-icon" />
                    <div className="import-info">
                      <h4>Ready to Import</h4>
                      <p>{newCount} new records ready for database import</p>
                    </div>
                  </div>
                  
                  <form onSubmit={sendToDatabase} className="import-form">
                    <div className="form-group compact">
                      <label htmlFor="circle_id" className="form-label">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        Select Circle
                      </label>
                      <select 
                        id="circle_id" 
                        name="circle_id" 
                        required
                        value={circle_id}
                        onChange={handleChange}
                        className="form-select"
                        disabled={importLoading}
                      >
                        <option value="">Choose a circle...</option>
                        {renderCircleOptions()}
                      </select>
                    </div>
                    
                    <button 
                      type="submit"
                      className={`import-button ${importLoading ? 'loading' : ''}`}
                      disabled={importLoading || !circle_id}
                    >
                      {importLoading ? (
                        <>
                          <FontAwesomeIcon icon={faSync} className="spinning" />
                          Importing...
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faDatabase} />
                          Import to Database
                        </>
                      )}
                    </button>
                  </form>
                </div>
              )}
            </div>

            {/* Data Table */}
            <div className="table-card">
              <div className="table-header">
                <div className="table-info">
                  <FontAwesomeIcon icon={faListAlt} />
                  <span>
                    Showing {filteredData().length} of {data.length} records
                    {activeTab !== 'all' && ` (${activeTab} only)`}
                  </span>
                </div>
                <div className="table-actions">
                  <button className="action-btn" title="Refresh">
                    <FontAwesomeIcon icon={faSync} />
                  </button>
                  <button className="action-btn" title="Export">
                    <FontAwesomeIcon icon={faDownload} />
                  </button>
                </div>
              </div>

              <div className="table-container">
                <div className="table-scroll">
                  <table className="modern-table">
                    <thead>
                      <tr>
                        <th className="index-col">#</th>
                        {headers.map((header, index) => (
                          <th key={index} className={header === 'card_number' ? 'card-number-col highlighted' : ''}>
                            <div className="column-header">
                              <span className="header-text">{header || `Column ${index + 1}`}</span>
                              {header === 'card_number' && (
                                <span className="column-tag">
                                  <FontAwesomeIcon icon={faFilter} />
                                  Key Field
                                </span>
                              )}
                            </div>
                          </th>
                        ))}
                        <th className="status-col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData().map((row, index) => {
                        const status = getRowStatus(row);
                        const displayIndex = row._originalIndex + 1;
                        
                        return (
                          <tr key={index} className={`table-row ${status.status}-row`}>
                            <td className="index-cell">
                              <span className="row-number">{displayIndex}</span>
                            </td>
                            {headers.map((header, colIndex) => (
                              <td key={colIndex} className={header === 'card_number' ? 'card-number-cell highlighted' : ''}>
                                <div className="cell-content">
                                  {row[colIndex] || (
                                    <span className="empty-value">—</span>
                                  )}
                                </div>
                              </td>
                            ))}
                            <td className="status-cell">
                              <div className={`status-indicator ${status.status}`}>
                                <FontAwesomeIcon icon={status.icon} />
                                <span className="status-text">{status.text}</span>
                                
                                {/* زانیاری دووبارە */}
                                {status.status === 'exists' && status.duplicateInfo && (
                                  <div className="duplicate-popover-trigger">
                                    <FontAwesomeIcon icon={faEye} className="info-icon" />
                                    {renderDuplicateDetails(status.duplicateInfo)}
                                  </div>
                                )}
                                
                                {/* هەڵەکانی validation */}
                                {status.errors && status.errors.length > 0 && (
                                  <div className="error-popover">
                                    <div className="error-list">
                                      {status.errors.map((error, i) => (
                                        <div key={i} className="error-item">
                                          <strong>{error.field}:</strong> {error.error}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                
                {filteredData().length === 0 && (
                  <div className="empty-table-state">
                    <FontAwesomeIcon icon={faInfoCircle} className="empty-icon" />
                    <h3>No records found</h3>
                    <p>No {activeTab === 'all' ? '' : activeTab} records match your current view.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExcelImport;